import React from "react";
import {
  View,
  ScrollView,
  StyleSheet,
  Animated,
  TouchableOpacity,
  Image,
  Button,
  Dimensions,
  Modal,
  ImageBackground,
  ActivityIndicator,
  RefreshControl,
  Platform,
  TouchableWithoutFeedback
} from "react-native";

import { connect } from "react-redux";
// import AdsScreen from '../Ads';
// import Video from 'react-native-video';
import { getCourses, clearAllCoursesData } from "../../store/action";
// import StylesColors from '../Colors';
// import LinearGradientComponent from '../HeaderBackgroundComponent';
// const { width, height } = Dimensions.get("window");
import { Searchbar, Avatar, Surface } from "react-native-paper";
// import OfflineHandler from '../OfflineHandler';
// import SubscribeNowForFullScreenDialog from '../fullScreenLoadingComponent';
import { coursesFromAllSubjectsData } from "./../../store/selector";
import { Text, Styles,Config } from "./../../components/UI-Components";
import { PaymentStrip } from "./../../components";
import Container from '@material-ui/core/Container';
import LoadingComponent from "./../../components/LoaderComponent";
// import EmptyFullscreen from '../EmptyFullScreen';

import RatingsComponent from "./ratingComponent";
import Header from "./../../components/Header/index";

const emptySubjectScreen = require("./../../assets/emptyLibrary.png");

const width = 480;
// const { width, height } = Dimensions.get("window"); 

const _width = window.innerWidth
const redBoxImage = require("./../../assets/TagRed.png");
const greenBoxImage = require("./../../assets/TagGreen.png");
const currentAffairsImg = require("./../../assets/current_affairs.png");
const avatarImg = require("./../../assets/avatar.jpeg");
const priceTag = require("./../../assets/priceStrip.png");

// const SubjectPriceComponent = ({
//   actualPrice,
//   discountPrice,
//   isFree,
//   isDiscount,
// }) => {
//   let price = isFree ? "Free" : isDiscount ? "₹" + discountPrice : " ";
//   const _isFree =
//     isFree || actualPrice < 1 || (isDiscount && discountPrice < 1);

//   return (
//     <>
//       <View style={styles.priceComponent}>
//         <View
//           style={[
//             styles.priceInnerComponent,
//             {
//               backgroundColor: _isFree ? "#42BF32" : "#FF7600",
//               justifyContent:
//                 _isFree || !isDiscount ? "flex-end" : "space-between",
//             },
//           ]}
//         >
         
//           {isDiscount && discountPrice >= 1 ? (
//             <Text style={styles.priceTitle}>{isFree ? "" : price}</Text>
//           ) : null}
//           <Text
//             style={[
//               isDiscount && discountPrice >= 1 && !isFree
//                 ? styles.strikePrice
//                 : styles.priceTitle,
//               { paddingLeft: 10 },
//             ]}
//           >
//             {_isFree ? "Free" : `₹${actualPrice}`}
//           </Text>
//         </View>
//       </View>
//     </>
//   );
// };

// const CourseComponent = ({
//   item = {},
//   isFree,
//   name,
//   isUserPaid,
//   examId,
//   examName,
//   history
// }) => {
//   const price = (item.is_discounted && !item.discount_price) ? 0 : item.is_discounted ? item.discount_price : item.actual_price;
//   const hasUserPaid = !!(item.is_user_paid && item.is_user_paid[0]);
//   return (
//     <div className="course-component">
//       <Surface style={styles.courseWrapper}>
//         <TouchableOpacity
//           onPress={() => {
       
//             history.push(
//             '/lessonPlanner', {
//                     courseId: item.id,
//                     hasUserPaid: !!(item.is_user_paid && item.is_user_paid[0]),
//                     price: (item.is_discounted && !item.discount_price) ? 0 : item.is_discounted ? item.discount_price : item.actual_price,
//                     isFree: isFree,
//                     examId: examId,
//                     examName: examName
//             }
//             );
//           }}
//         >
//           <View style={styles.mainImageView}>
//             <View style={{ flex: 2 }}>
//               <Image
//                 style={styles.ImageView}
//                 source={{
//                   uri: item.course_image || 'https://i.ytimg.com/vi/BfCwN4iy6T8/maxresdefault.jpg',
//                 }}
//               />
//             </View>
//             {/* <Text style={{fontSize:14,marginLeft:5,justifyContent:'center',alignItems:'center'}}>{item.subject_name}</Text> */}
//           </View>
//           <View style={styles.courseInfo}>
//             <Text
//               style={styles.courseTitle}
//               ellipsizeMode="tail"
//               numberOfLines={2}
//             >
//               {name}
//             </Text>
//           </View>
//           {/* <RatingsComponent ratings={item.admin_rating} />
//           <View style={styles.authorInfo}>
//             <Text
//               style={styles.authorName}
//               ellipsizeMode="tail"
//               numberOfLines={1}
//             >
//               {item.faculty &&
//                 item.faculty.first_name + " " + item.faculty.last_name}
//             </Text>
//           </View>
//           <View style={styles.avatarImage}>
//             <Avatar.Image
//               size={48}
//               source={{ uri: item.faculty && item.faculty.profile_pic }}
//               style={{ backgroundColor: "#fff" }}
//               color={"#ccc"}
//             />
//           </View> */}
//         </TouchableOpacity>
//         {Config.coursePaymentTag && !isUserPaid  ? (
//           <SubjectPriceComponent
//             isFree={isFree}
//             actualPrice={item.actual_price}
//             discountPrice={item.discount_price}
//             isDiscount={item.is_discounted}
//             hasUserPaid={!!item.has_user_paid}
//           />
//         )
//        : null
//       }
//       </Surface>
//     </div>
//   );
// };

const SubjectComponent = ({item={}, isFree, name, navigation, isUserPaid, examId, examName, key}) => {
  
  //    const { has_userPaid, is_free, is_discount, actualPrice, discountPrice} = item
     const price = item.is_discounted ? item.discount_price : item.actual_price
     return(
         <>
          
          <TouchableWithoutFeedback
            onPress={() => navigation.push('/lessonPlanner', {
              courseId: item.id,
              // subjectName: item.library_subject_name,
              
              hasUserPaid: !!(item.is_user_paid && item.is_user_paid[0]),
              price: (item.is_discounted && !item.discount_price) ? 0 : item.is_discounted ? item.discount_price : item.actual_price,
              isFree: isFree,
              examId: examId,
              examName: examName
             
          })}
          
          >
          <View key={key}  style={{position: 'relative'}}  >
           
             {
                 !isUserPaid && !isFree &&
                  <View style={styles.paymentTag}>
                      <PaymentStrip
                        price={price}
                        isFree={isFree}
                        discount={item.is_discounted}
                        actualPrice={item.actual_price}
                      />
                  </View>
             }
              <View style={styles.subjectContainer}>
          
                  <View style={styles.imageContainer}>
                  <View 
                  style={{
                      ...StyleSheet.absoluteFill,
                      backgroundColor: 'rgba(0,0,0,0.70)',
                      zIndex: 1,
                     
                      borderTopLeftRadius: 15,
                      borderTopRightRadius: 15,
                  }}
              >
  
              </View>
                      <Image style={styles.imageIcon} 
                      source={{uri: item.course_image || 'https://i.ytimg.com/vi/BfCwN4iy6T8/maxresdefault.jpg'}}
                      resizeMode='cover'
                      />
                  </View>
                 
                  <View style={styles.titleComponent}>
                      <Text style={styles.title}
                      ellipsizeMode='tail'
                      numberOfLines={2}
                      >
                         {name}
                      </Text>
                  </View>
                  <View style={styles.facultyInfo}>
                      <View style={{flex:1, flexDirection: 'row', alignItems :'center'}}>
                      <Image  source={{uri: item.faculty && item.faculty.profile_pic }} 
                       style={{
                          width: 28,
                          height: 28,
                          borderRadius: 100,
                         
                      }}/>
                      <Text 
                      style={{fontSize: 13, 
                        fontWeight: '700', 
                        color: '#000', 
                        flex: 1 ,
                        marginHorizontal: 5,
                       }} 
                        ellipsizeMode='tail'
                        numberOfLines={1}
                      > {item.faculty && (item.faculty.first_name + ' ' + item.faculty.last_name)}</Text>
                      </View>
                      <View style={styles.rating}>
                          {/* <Image source={star} style={{width: 12, height: 12,}}/> */}
                          {/* <Icons name='ios-star' size={10} color='gold' /> */}
                  <Text style={{color: '#fff', marginLeft: 4, fontSize: 10}}>{item.admin_rating || 4.5 }</Text>
                      </View>
                  </View>
              </View>
             
        
          </View>
          </TouchableWithoutFeedback>
          </>
      )
  }

class CoursesList extends React.Component {
  state = {
    query: "",
    refreshing: false,
    coursesInfo: null,
    showMessage: false,
  };

  componentDidUpdate(prevProps) {
    if (prevProps.coursesInfo !== this.props.coursesInfo) {
      if (this.props.coursesInfo) {
        this.setState({
          coursesInfo: this.props.coursesInfo,
          refreshing: false,
        });
      }
    }
  }

  handleSearch = (text) => {
    const formatData = text.toLowerCase();

    this.setState({ query: text }, () => {
      const filteredData =
        this.props.coursesInfo &&
        this.props.coursesInfo.length &&
        this.props.coursesInfo.filter((x) => {
          if (
            x &&
            x.course_name &&
            x.course_name.toLowerCase().includes(formatData)
          ) {
            return x;
          }
        });
      //   console.log(chooseSubjectData.length <=0 )
      //   const _choose = chooseSubjectData.length === 0;
      //   if(_choose){
      //       this.setState({
      //           isSearch: true
      //       })
      //   }
      // if(chooseSubjectData.length <= 0) return
      this.setState({
        coursesInfo: filteredData,
      });
    });
  };

  componentDidMount() {
    this.fetchCourses();

    setTimeout(() => {
      this.setState({ showMessage: true });
    }, 800);
  }

  fetchCourses = () => {
    const { match } = this.props;
    const { params } = match;
    const { examId } = params || {};
    // const examId = this.props.navigation.getParam('examId');
    this.props.getCourses(examId);
    this.setState({
      examId: examId,
    });
  };

  componentWillUnmount() {
    this.props.clearAllCoursesData();
  }

  fetchSubjects = () => {
    if (!(this.props.librarySubjects && this.props.librarySubjects.length)) {
      const examId = this.props.navigation.getParam("examId", null);
      if (examId) {
        this.setState({
          examId,
        });
        this.props.getSubjectByExam(examId);
      }
    }
  };

  // refreshLibrary = () => {
  //     this.setState({
  //         refreshing: true
  //     }, this.fetchCourses)
  // }

  isAd = () => {
    this.setState({
      isAdShow: true,
    });
  };
  render() {
    const item = null;

    const { query, _librarySubjects, showMessage } = this.state;
    return (
      <>
        <Header
          title="Classes"
          headerRight
          headerRightClick={() => this.props.history.push('/Home')}
          headerLeftClick={() => this.props.history.goBack()}
          backButton={true}
          // headerRightClick={() => alert()}
        />
        
        <Container maxWidth='lg'>
        {this.props.loading &&  (
              <View
                style={{
                  flex: 1,
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <LoadingComponent styles={{width: 250, height: 250}} />                    

              </View>
            )}
        <div className="main-component"
          // style={{
          //   flex: 1,
          //   backgroundColor: Styles.white,
          //   height: "90vh",
          //   elevation: 4,
          //   paddingVertical: 30,
          // }}
        >
          
          {/* <BackHandlerAndroid goBack={true} /> */}
          {/* <OfflineHandler callBack={this.fetchCourses} /> */}

          {/* {this.state.coursesInfo &&
            this.state.coursesInfo.length > 0 &&
            !this.props.loading &&
            !this.props.error && (
              <Searchbar
                placeholder="Search Subject"
                onChangeText={(_query) => {
                  this.setState({ query: _query });
                }}
                value={query}
                style={{ margin: 8 }}
                onChangeText={this.handleSearch}
                onFocus={() => {
                  this.setState({
                    isSearch: true,
                  });
                }}
              />
            )} */}

          <ScrollView
          // refreshControl={
          //     <RefreshControl
          //     refreshing={this.state.refreshing}
          //     onRefresh={this.refreshLibrary}
          //     />
          // }
          >
           

            {this.props.error && (
              <View
                style={{
                  flex: 1,
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Text>
                  {
                  typeof this.props.errInfo === "string"
                    ? this.props.errInfo
                    : "something went wrong..."}
                </Text>
              </View>
            )}
            {
              <>
                     {
                            this.state.coursesInfo && this.state.coursesInfo.length > 0 &&
                            <View style={{flex: 1, 
                                marginHorizontal: 10, marginTop: 8}}>
                                <Text style={{ fontSize: 20,  fontWeight: '700',}}>Subjects</Text>
                            </View>
                        }
                   <View style={styles.examContainer}>
                       {
                           this.state.coursesInfo && this.state.coursesInfo.length > 0 ? 
                            this.state.coursesInfo.map((course, index) => {
                                const { is_user_paid, actual_price, discount_price, is_discounted } = course;
                                const isFree = parseInt(actual_price) === 0 || (is_discounted && parseInt(discount_price) === 0) 
                             
                                const isUserPaid = is_user_paid && is_user_paid[0] && typeof is_user_paid[0] === 'object' && Object.keys(is_user_paid[0]).length > 0 ? true : false;
                               return(
                                <SubjectComponent
                                    key={index}
                                    navigation={this.props.history}
                                    item={course}
                                    isFree={isFree}
                                    examName={course.exam.exam_name}
                                    name={course.course_name}
                                    isUserPaid={isUserPaid}
                                    examId={this.state.examId}
                                />
                               )
                           }) : null
                       }
                   
                   </View>
              </>
            }
          </ScrollView>
        </div>
        </Container>
        {showMessage &&
          !(this.state.coursesInfo && this.state.coursesInfo.length > 0) &&
          !this.props.loading &&
          !this.props.errInfo && (
            <View style={styles.noCoursesStyle}>
              <Text style={{ fontSize: 20, fontWeight: "700" }}>
                Will be updated soon
              </Text>
            </View>
          )}
        {/* <AdsScreen screenName={'Courses'} isAdCallBack={this.isAd}/> */}
      </>
    );
  }
}
const styles = StyleSheet.create({
  courseContainer: {
    marginBottom: 12,
   
  },
  allCoursesWrapper: {
    paddingHorizontal: 12,
    marginTop: 20,
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between",
    alignItems: "center",
    
  },
  examContainer: {
    flexDirection: 'row', 
    flexWrap: 'wrap',
    width: '100%',   
  },
  subjectContainer:{
    marginTop:10,
    // height: 120,
    width:_width <= 579 ?(_width - 35) :  Math.floor(width/2 - 20),
    borderRadius:15,
    borderWidth: 3,
    borderColor: "#fff",
    marginHorizontal: _width <= 579  ? 0 : 12,
    flexDirection: 'column',
    justifyContent: 'flex-start',
    backgroundColor: '#ecf2f6',
    position: 'relative',
    
    
   
},
imageContainer:{
  flex: 1,   

}, 
imageIcon:{
  width:_width <= 579 ? (_width - 42) : Math.floor(width/2 - 25),
  borderTopLeftRadius: 10,
  borderTopRightRadius: 10,
  height:120,
 
},
titleComponent: {
  marginBottom: 10,
  paddingVertical: 10,
  paddingHorizontal: 6,
  flexWrap: 'wrap',
  marginHorizontal: 2,
  borderBottomWidth: 0.35,
  
  borderBottomColor: 'rgba(0,0,0,0.45)'

},
title: {
  fontSize: 13,
  fontWeight: 'bold',
  width: Math.floor(width / 2 - 50),
  textTransform: 'uppercase',
  alignSelf: 'center',
  color: '#000',    
  
},
facultyInfo: {
  marginBottom: 10,
  // paddingVertical: 10,
  paddingHorizontal: 6,
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginHorizontal: 2,
},
rating: {
  flexDirection: 'row',
  borderRadius: 15,
  width: 50,
  backgroundColor: '#000',
  paddingVertical: 3,
  // width: 52,
  justifyContent: 'space-between',
  alignItems: 'center',
  // marginHorizontal: 5,
  paddingHorizontal: 10

},
paymentTag: {
  position: 'absolute',
  top: 30,
  right: _width <= 579 ?  1 : 14,
  zIndex: 1000,
 
},
  courseWrapper: {
    marginTop: 0,
        elevation: 10,       
        borderRadius: 10,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        paddingHorizontal: 6,
        marginBottom: 20,
        borderLeftColor: Styles.dangerColor,
        borderLeftWidth: 10,
        borderTopLeftRadius: 10,
        borderBottomLeftRadius: 10,
    cursor: 'pointer',
    // alignSelf: _width <= 360 ? 'center': 'none',
    // margin: _width <= 360 ? 'auto' : 'initial'
  },
  courseInfo: {
    marginBottom: 4,
    paddingVertical: 10,
        // paddingHorizontal: 6,
        alignItems: 'center',
        justifyContent: 'center'
  },
  courseTitle: {
    fontSize: 14,
    fontWeight: "600",
    width: Math.floor(width / 2 - 36),
    textTransform: "uppercase",
    
  },
  authorInfo: {
    paddingVertical: 8,
  },
  authorName: {
    fontSize: 13,
    color: "rgba(0,0,0,0.7)",
    fontWeight: "500",
    width: Math.floor(width / 2 - 80),
    textTransform: "capitalize",
  },
  avatarImage: {
    right: 0,
    zIndex: 1000,
    position: "absolute",
    bottom: -24,
  },
  mainImageView: {
    // width: Math.floor(width / 2 - 30),
    height: 150,
    // marginHorizontal: 12,
    // marginBottom,
    justifyContent: "center",
    marginHorizontal: -6,
  },
  ImageView: {
    flex: 1,
    minWidth: Math.floor(480 / 2 - 24),
    borderRadius: 10,
    borderBottomLeftRadius: 0,
    borderTopLeftRadius: 0,
    borderBottomRightRadius: 0,
    marginBottom: 5,
    backgroundColor: '#fff'
  },
  container: {
    flex: 1,
    borderWidth: 1,
  },
  closeBtn: {
    fontWeight: "800",
    position: "absolute",
    top: 50,
    right: 15,
    zIndex: 99999,
    fontSize: 24,
    color: "#fff",
    alignItems: "center",
  },
  priceComponent: {
    // backgroundColor: 'red',
    position: "absolute",
    // width: 80,
    top: 10,
    right: 0,
    // padding:2,
    // height: 20,
    // fontSize:12,

    // justifyContent: 'flex-end',
    // alignItems: 'flex-end',
    // shadowColor: "#f00",
    // shadowOffset: {
    //     width: 20,
    //     height: 12,
    // },
    // shadowOpacity: 0.58,
    // shadowRadius: 16.00,
    // elevation: 24,
    // paddingHorizontal: 8,
  },
  priceInnerComponent: {
    minWidth: 60,
    height: 20,
    flexDirection: "row",
    alignItems: "center",
    // paddingHorizontal: 8,
    zIndex: 1000,
    //    paddingHorizontal: 4
    // paddingLeft: 5,
    // marginRight: 0
    paddingHorizontal: 6,
  },
  priceTitle: {
    color: "#fff",
    fontSize: 11,
    alignSelf: "center",
    // marginTop: -7
  },
  strikePrice: {
    color: "#fff",
    fontSize: 11,
    textDecorationLine: "line-through",
    alignSelf: "center",
    // marginTop: -7
  },
  noCoursesStyle: {
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "100%",
    backgroundColor: "#ffff",
  },
});

const mapStateToProps = (state) => {
  
  const courses = coursesFromAllSubjectsData(state);
  

  return {
    loading:
      state.coursesInfo &&
      state.coursesInfo.loading &&
      state.coursesInfo.loading,
    error:
      state.coursesInfo && state.coursesInfo.error && state.coursesInfo.error,
    errInfo:
      state.coursesInfo &&
      state.coursesInfo.errInfo &&
      state.coursesInfo.errInfo.data &&
      state.coursesInfo.errInfo.data.message,
    // accessToLibrary: libraryFullAccess,
    coursesInfo: courses,
  };
};

export default connect(mapStateToProps, { getCourses, clearAllCoursesData })(
  CoursesList
);
